export default "__VITE_ASSET__DwVPSBQu__"